import React from 'react';
import PropagateLoader from 'react-spinners/PropagateLoader';

const Loader = ({ size, color, height }) => {
  return (
    <div
      className={`flex w-full items-center justify-center ${height ? height : 'h-[150px]'} !my-[24px]`}
    >
      <PropagateLoader size={size ? size : 20} color={color ? color : '#000'} />
    </div>
  );
};

export default Loader;
